import { RenderFunc } from '../types/RenderFunc';

export const renderBoolean: RenderFunc = item => {
  const { newValue, oldValue } = item;
  let oldValueText = '';
  let newValueText = '';

  if (oldValue === true) {
    oldValueText = 'Да';
  } else if (oldValue === false) {
    oldValueText = 'Нет';
  }
  if (newValue === true) {
    newValueText = 'Да';
  } else if (newValue === false) {
    newValueText = 'Нет';
  }

  return {
    renderedOldValue: oldValueText,
    renderedNewValue: newValueText,
  };
};
